/* eslint-disable prefer-template */
/* eslint-disable default-param-last */
import { actionType } from 'Config/actionTypes';

const INITIAL_STATE = {
  data: [],
  isLoading: false,
  isError: false,
  msgError: '',
};
export const jobPositionReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionType.JOB_POSITION + '_LOADING':
      return {
        ...state,
        isLoading: true,
      };
    case actionType.JOB_POSITION + '_RESULT':
      return {
        ...state,
        data: action.result.data,
        isLoading: false,
        isError: false,
        msgError: '',
      };
    case actionType.JOB_POSITION + '_FAILED':
      return {
        ...state,
        isError: true,
        msgError: action.err,
        isLoading: false,
      };
    default:
      return state;
  }
};
